import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { Message } from '../../types';
import MessageSubTypes from '../../models/enums/MessageSubTypes';

import styles from './MessageHeader.module.css';

export function MessageHeader({ message }: { message: Message }) {
  const { subType } = message;
  const isSmsAutomatedOptMessage =
    subType === MessageSubTypes.SMS_OPT_OUT_NOTIFICATION ||
    subType === MessageSubTypes.SMS_OPT_IN_NOTIFICATION;
  const isVwrBotMessage = subType === MessageSubTypes.CHATBOT_MESSAGE;

  if (!isSmsAutomatedOptMessage && !isVwrBotMessage) return null;

  let text;
  if (isSmsAutomatedOptMessage) {
    const isOptedOut = subType === MessageSubTypes.SMS_OPT_OUT_NOTIFICATION;
    text = <FormattedMessage id={`message.smsOpt${isOptedOut ? 'Out' : 'In'}`} />;
  } else if (isVwrBotMessage) {
    text = message?.metadata?.[0]?.payload?.title;
  }

  return (
    <div
      className={classNames(styles.messageHeader, {
        [styles.priorityMessage]: isSmsAutomatedOptMessage,
        [styles.welcomeMessage]: isVwrBotMessage,
      })}
    >
      {text}
    </div>
  );
}

export default MessageHeader;
